import backArrow from "assets/images/back-arrow.svg";
import classNames from "classnames";
import {common as strings} from "strings";

import Button from "components/Button";

import styles from "./MobileNavigationHeader.module.css";

export default function MobileNavigationHeader(props: {
  backTo?: string;
  rightLink?: {label: string; to: string};
  alwaysShown?: boolean;
  onBack?: () => void;
}) {
  return (
    <header
      className={classNames(
        props.alwaysShown ? styles.alwaysShown : styles.header,
        props.rightLink ? styles.flexEnd : null,
      )}
    >
      {props.backTo !== undefined ? (
        <Button
          variant="minimal"
          iconLeft={() => <img src={backArrow} alt="" />}
          className={styles.back}
          labelClassName={styles.backLabel}
          to={props.backTo}
        >
          {strings.back}
        </Button>
      ) : null}
      {props.rightLink ? (
        <div className={styles.fitContent}>
          <Button variant="minimal" to={props.rightLink.to}>
            {props.rightLink.label}
          </Button>
        </div>
      ) : null}
      {props.onBack !== undefined ? (
        <Button
          variant="minimal"
          iconLeft={() => <img src={backArrow} alt="" />}
          className={styles.back}
          labelClassName={styles.backLabel}
          onClick={props.onBack}
        >
          {strings.back}
        </Button>
      ) : null}
    </header>
  );
}
